import { currentUserShowSuccess } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { denormalisedResponseEntities } from '../../util/data';

// ================ Action types ================ //

export const UPDATE_PROFILE_REQUEST = 'app/EditCreatorProfilePage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/EditCreatorProfilePage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/EditCreatorProfilePage/UPDATE_PROFILE_ERROR';

export const CLEAR_UPDATED_TAB = 'app/EditCreatorProfilePage/CLEAR_UPDATED_TAB';

// ================ Reducer ================ //

const initialState = {
  updateInProgress: false,
  updateProfileError: null,
  uploadImageError: null,
  submitted: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
        submitted: false,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        updateInProgress: false,
        submitted: true,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        updateInProgress: false,
        updateProfileError: payload,
        submitted: false,
      };
    case CLEAR_UPDATED_TAB:
      return {
        ...state,
        updatedTab: null,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const updateProfileRequest = () => ({ type: UPDATE_PROFILE_REQUEST });
export const updateProfileSuccess = () => ({ type: UPDATE_PROFILE_SUCCESS });
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

export const clearUpdatedTab = () => ({ type: CLEAR_UPDATED_TAB });

// ================ Thunks ================ //

/**
 * Update user's profile data with new publicData fields
 */
export const updateProfile = params => (dispatch, getState, sdk) => {
  dispatch(updateProfileRequest());

  const queryParams = {
    expand: true,
    include: ['profileImage'],
    'fields.image': ['variants.square-small', 'variants.square-medium'],
  };

  return sdk.currentUser
    .updateProfile(params, queryParams)
    .then(response => {
      dispatch(updateProfileSuccess());

      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
      }
      const currentUser = entities[0];

      // Update current user in state.user.currentUser through user.duck.js
      dispatch(currentUserShowSuccess(currentUser));
    })
    .catch(e => {
      log.error(e, 'update-profile-failed', {
        error: e.message,
        params: params,
      });
      dispatch(updateProfileError(storableError(e)));
    });
};
